// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UBqoO","gradient":"styles_gradient__dsy1U"};